import { AutoCompleteProps } from 'antd';
import CustomAutoComplete from 'components/CustomAutoComplete';
import { useSearchSiret } from 'hooks/siret.hooks';
import React from 'react';
import { Company } from 'types/Company';
import { removeSiretSpaces } from 'utils/siret';

interface SiretInputProps
  extends Omit<AutoCompleteProps<Company>, 'placeholder'> {
  placeholder?: string;
}

export default function SiretInput({
  value,
  placeholder,
  onSearch,
  onSelect,
  ...props
}: SiretInputProps) {
  // Wrap onSearch to remove all spaces from SIRET input automatically
  const handleSearch = (searchValue: string) => {
    const cleanedValue = removeSiretSpaces(searchValue);
    onSearch?.(cleanedValue);
  };

  const searchProps = useSearchSiret({
    onSearch: handleSearch,
    onSelect,
  });

  // Clean the displayed value by removing spaces
  const cleanedValue =
    value && typeof value === 'string'
      ? removeSiretSpaces(value as string)
      : value;

  return (
    <CustomAutoComplete
      {...props}
      {...searchProps}
      value={cleanedValue}
      placeholder={placeholder}
    />
  );
}
